"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Column", {
  enumerable: true,
  get: function get() {
    return _Column.default;
  }
});
exports.Columns = exports.componentTypeIsSame = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Column = _interopRequireDefault(require("./Column"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var componentTypeIsSame = function componentTypeIsSame(Component, type) {
  // https://github.com/gatsbyjs/gatsby/issues/3486#issuecomment-364163889
  return type === Component || type === (0, _core.jsx)(Component, null).type;
};

exports.componentTypeIsSame = componentTypeIsSame;

var Columns = function Columns(_ref) {
  var children = _ref.children,
      className = _ref.className,
      middle = _ref.middle,
      gutterSize = _ref.gutterSize,
      gutters = _ref.gutters,
      split = _ref.split,
      reverse = _ref.reverse,
      stack = _ref.stack;
  var gutterUnit = gutterSize || gutters && 1; // Verify and augment children columns

  children = _react.default.Children.map(children, function (child) {
    if (!child) return;
    if (!componentTypeIsSame(_Column.default, child.type)) throw new Error('<Columns> can only have <Column> as a direct child');
    return _react.default.cloneElement(child, _objectSpread({}, child.props, {
      stack: stack,
      gutterUnit: gutterUnit,
      split: split
    }));
  }); // When stack is enabled, we don't return traces of the columns div tags

  if (stack) return (0, _core.jsx)(_react.Fragment, null, children);
  var styles =
  /*#__PURE__*/
  (0, _core.css)("display:flex;box-sizing:border-box;", middle && 'align-items: center;', " ", split && 'justify-content: space-between;', " ", reverse && 'flex-direction: row-reverse;', " ", gutterUnit && 'margin-left: ' + gutterUnit * -0.5 + 'em;', " ", gutterUnit && 'margin-right: ' + gutterUnit * -0.5 + 'em;', "label:styles;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvQ29sdW1ucy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3Qm9CIiwiZmlsZSI6Ii4uL3NyYy9saWIvQ29sdW1ucy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGcmFnbWVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IGNsYXNzbmFtZXMgZnJvbSAnY2xhc3NuYW1lcydcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgQ29sdW1uIGZyb20gJy4vQ29sdW1uJ1xuXG5leHBvcnQgY29uc3QgY29tcG9uZW50VHlwZUlzU2FtZSA9IChDb21wb25lbnQsIHR5cGUpID0+IHtcbiAgLy8gaHR0cHM6Ly9naXRodWIuY29tL2dhdHNieWpzL2dhdHNieS9pc3N1ZXMvMzQ4NiNpc3N1ZWNvbW1lbnQtMzY0MTYzODg5XG4gIHJldHVybiB0eXBlID09PSBDb21wb25lbnQgfHwgdHlwZSA9PT0gPENvbXBvbmVudCAvPi50eXBlXG59XG5cbmNvbnN0IENvbHVtbnMgPSAoeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBtaWRkbGUsIGd1dHRlclNpemUsIGd1dHRlcnMsIHNwbGl0LCByZXZlcnNlLCBzdGFjayB9KSA9PiB7XG4gIGNvbnN0IGd1dHRlclVuaXQgPSBndXR0ZXJTaXplIHx8IChndXR0ZXJzICYmIDEpXG5cbiAgLy8gVmVyaWZ5IGFuZCBhdWdtZW50IGNoaWxkcmVuIGNvbHVtbnNcbiAgY2hpbGRyZW4gPSBSZWFjdC5DaGlsZHJlbi5tYXAoY2hpbGRyZW4sIGNoaWxkID0+IHtcbiAgICBpZiAoIWNoaWxkKSByZXR1cm5cbiAgICBpZiAoIWNvbXBvbmVudFR5cGVJc1NhbWUoQ29sdW1uLCBjaGlsZC50eXBlKSkgdGhyb3cgbmV3IEVycm9yKCc8Q29sdW1ucz4gY2FuIG9ubHkgaGF2ZSA8Q29sdW1uPiBhcyBhIGRpcmVjdCBjaGlsZCcpXG4gICAgcmV0dXJuIFJlYWN0LmNsb25lRWxlbWVudChjaGlsZCwgeyAuLi5jaGlsZC5wcm9wcywgc3RhY2ssIGd1dHRlclVuaXQsIHNwbGl0IH0pXG4gIH0pXG5cbiAgLy8gV2hlbiBzdGFjayBpcyBlbmFibGVkLCB3ZSBkb24ndCByZXR1cm4gdHJhY2VzIG9mIHRoZSBjb2x1bW5zIGRpdiB0YWdzXG4gIGlmIChzdGFjaykgcmV0dXJuIDxGcmFnbWVudD57Y2hpbGRyZW59PC9GcmFnbWVudD5cblxuICBjb25zdCBzdHlsZXMgPSBjc3NgXG4gICAgZGlzcGxheTogZmxleDtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgICR7bWlkZGxlICYmICdhbGlnbi1pdGVtczogY2VudGVyOyd9XG4gICAgJHtzcGxpdCAmJiAnanVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuOyd9XG4gICAgJHtyZXZlcnNlICYmICdmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2U7J31cbiAgICAke2d1dHRlclVuaXQgJiYgJ21hcmdpbi1sZWZ0OiAnICsgZ3V0dGVyVW5pdCAqIC0wLjUgKyAnZW07J31cbiAgICAke2d1dHRlclVuaXQgJiYgJ21hcmdpbi1yaWdodDogJyArIGd1dHRlclVuaXQgKiAtMC41ICsgJ2VtOyd9XG4gIGBcblxuICBjb25zdCBjbGFzc05hbWVzID0gY2xhc3NuYW1lcygncmVhY3QtZmxleC1jb2x1bW5zJywgY2xhc3NOYW1lLCB7XG4gICAgJ3JlYWN0LWZsZXgtY29sdW1ucy1hbGlnbi1taWRkbGUnOiAhIW1pZGRsZSxcbiAgICAncmVhY3QtZmxleC1jb2x1bW5zLXNwbGl0JzogISFzcGxpdCxcbiAgICAncmVhY3QtZmxleC1jb2x1bW5zLXJldmVyc2UnOiAhIXJldmVyc2VcbiAgfSlcblxuICByZXR1cm4gPGRpdiBjbGFzc05hbWU9e2NsYXNzTmFtZXN9IGNzcz17c3R5bGVzfT57Y2hpbGRyZW59PC9kaXY+XG59XG5cbkNvbHVtbnMuZGVmYXVsdFByb3BzID0ge1xuICBtaWRkbGU6IGZhbHNlLFxuICBndXR0ZXJTaXplOiBudWxsLFxuICBndXR0ZXJzOiBudWxsLFxuICBzcGxpdDogZmFsc2UsXG4gIHJldmVyc2U6IGZhbHNlLFxuICBzdGFjazogZmFsc2Vcbn1cblxuQ29sdW1ucy5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgbWlkZGxlOiBQcm9wVHlwZXMuYm9vbCxcbiAgZ3V0dGVyU2l6ZTogUHJvcFR5cGVzLm51bWJlcixcbiAgZ3V0dGVyczogUHJvcFR5cGVzLmJvb2wsXG4gIHNwbGl0OiBQcm9wVHlwZXMuYm9vbCxcbiAgcmV2ZXJzZTogUHJvcFR5cGVzLmJvb2wsXG4gIHN0YWNrOiBQcm9wVHlwZXMuYm9vbFxufVxuXG5leHBvcnQgeyBDb2x1bW5zLCBDb2x1bW4gfVxuIl19 */"));
  var classNames = (0, _classnames.default)('react-flex-columns', className, {
    'react-flex-columns-align-middle': !!middle,
    'react-flex-columns-split': !!split,
    'react-flex-columns-reverse': !!reverse
  });
  return (0, _core.jsx)("div", {
    className: classNames,
    css: styles
  }, children);
};

exports.Columns = Columns;
Columns.defaultProps = {
  middle: false,
  gutterSize: null,
  gutters: null,
  split: false,
  reverse: false,
  stack: false
};
Columns.propTypes = {
  className: _propTypes.default.string,
  middle: _propTypes.default.bool,
  gutterSize: _propTypes.default.number,
  gutters: _propTypes.default.bool,
  split: _propTypes.default.bool,
  reverse: _propTypes.default.bool,
  stack: _propTypes.default.bool
};